export const MOBILE_MENU_TOGGLE_EVENT = "mobile-menu:toggle";
